export var types = {
    RESET_STATE: 'RESET_STATE',
    RESET_STATE_EXCEPT_AUTH: 'RESET_STATE_EXCEPT_AUTH',
};
export var resetState_AC = function () {
    return {
        type: types.RESET_STATE,
    };
};
export var resetStateExceptAuth_AC = function () {
    return {
        type: types.RESET_STATE_EXCEPT_AUTH,
    };
};
//# sourceMappingURL=root.js.map